import React, { PropsWithChildren } from 'react'
import Arrow from '@shared/svg/arrow.svg'
import cx from 'classnames'

import { IStateProps } from './model'

import styles from './style.module.scss'

export const View = ({
	title,
	onToggleExpanded,
	children,
	expanded,
}: PropsWithChildren<IStateProps>) => (
	<div className={cx(styles.wrap, { [styles.expanded]: expanded })}>
		<div
			tabIndex={0}
			onClick={onToggleExpanded}
			onKeyPress={onToggleExpanded}
			className={styles.title}
		>
			<h3 className={styles.titleText}>{title}</h3>
			{/*<div className={styles.titleArrowWrap}>*/}
			<Arrow className={styles.titleArrow} />
		</div>
		{/*</div>*/}
		<div className={styles.content}>{children}</div>
	</div>
)
